export enum FormControlNames {
    Street = 'street',
    HouseNumber = 'houseNumber',
    BusNumber = 'busNumber',
    ZipCode = 'zipCode',
    City = 'city',
    Country = 'country',
}
